<div *ngIf="!isMonitorMode" style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
  <button nz-button nzType="default" nz-dropdown [nzDropdownMenu]="typeMenu" [nzPlacement]="'bottomRight'">
    <i nz-icon nzType="filter" nzTheme="outline"></i> Filtrar por Tipo
    <span *ngIf="isTypeFilterActive" style="margin-left: 5px; color: #1890ff;">●</span>
  </button>
</div>

<div class="table-container" [class.monitor]="isMonitorMode">
  <nz-table #headerTable [nzData]="displayedData" 
    [nzScroll]="isMonitorMode ? { y: 'calc(100vh - 280px)' } : { y: '200px' }" 
    [nzShowPagination]="false">
    <thead>
      <tr>
        <th [nzWidth]="isMonitorMode ? '250px' : '150px'">Nome</th>
        <th [nzWidth]="isMonitorMode ? '150px' : '80px'">Realizados</th>
        <th [nzWidth]="isMonitorMode ? '150px' : '80px'">Em Andamento</th>
        <th [nzWidth]="isMonitorMode ? '150px' : '80px'">Cancelados</th>
      </tr>
    </thead>
    <tbody>
      @for (data of displayedData; track data.name) {
      <tr>
        <td [class.monitor-td]="isMonitorMode">
          <span [style.font-weight]="isMonitorMode ? 'bold' : 'normal'">{{ data.name }}</span>
        </td>
        <td [class.monitor-td]="isMonitorMode">{{ data.done }}</td>
        <td [class.monitor-td]="isMonitorMode">{{ data.in_progress }}</td>
        <td [class.monitor-td]="isMonitorMode">{{ data.canceled }}</td>
      </tr>
      }
    </tbody>
  </nz-table>
</div>

<nz-dropdown-menu #typeMenu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div style="padding: 8px">
      <input nz-input placeholder="Buscar tipo" [(ngModel)]="typeSearch" (ngModelChange)="onTypeSearch($event)" />
    </div>
    <div style="padding: 8px; max-height: 200px; overflow-y: auto; display: flex; flex-direction: column;">
      <label nz-checkbox *ngFor="let filter of visibleTypeFilters" [(ngModel)]="filter.checked">
        {{ filter.text }}
      </label>
    </div>
    <div style="padding: 8px; border-top: 1px solid #eee; display: flex; justify-content: space-between;">
      <button nz-button nzSize="small" nzType="primary" (click)="applyTypeFilter()">
        Filtrar
      </button>
      <button nz-button nzSize="small" (click)="clearTypeFilter()">
        Limpar
      </button>
    </div>
  </div>
</nz-dropdown-menu>